
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import Icon from "@/components/icons/AbilisText.vue";

import EPDCertificate from "@/components/icons/EPDCertificate.vue";
import AccountModule from "@/store/modules/account";
import { Role } from "@/global";
import config from "@/config";

@Component({ components: { Icon, EPDCertificate } })
export default class LoginView extends Vue {
  private accountState = getModule(AccountModule);

  mounted() {
    if (this.accountState.canReuseSession && this.accountState.idpTokenMatchesConfiguredRole) {
      this.loginRoute();
      return;
    }
  }

  created() {
    this.accountState.completeIfPossible().then(() => {
      if (!this.accountState.idpTokenMatchesConfiguredRole) {
        this.accountState.logout();
        this.$notify({
          text: this.$t("toasts.login.wrongRole").toString(),
          type: "error",
          duration: -1,
        });
        this.$router.replace({ name: "login" });
      } else {
        this.loginRoute();
      }
    });
  }

  get showRegisterLink(): boolean {
    return config.role == Role.Patient;
  }

  login() {
    if (this.accountState.hasValidToken && this.accountState.idpTokenMatchesConfiguredRole) {
      this.loginRoute();
    } else {
      this.accountState.startAuthFlow();
    }
  }

  loginRoute() {
    if (this.accountState.redirectPath) {
      this.$router.push(this.accountState.redirectPath);
      this.accountState.clearRedirectPath();
    } else {
      switch (this.accountState.role) {
        case Role.HealthcareProfessional:
        case Role.Assistant:
          this.$router.push({ name: "patients" });
          break;
        case Role.Patient:
        case Role.Representative:
          this.$router.push({ name: "timeline" });
          break;
      }
    }
  }
}
